// Converted from makeStyles to simple style object
const styles = {
    link: {
        display: "flex",
        textDecoration: "none",
    },
    icon: {
        marginRight: "4px",
        width: 20,
        height: 20,
    },
};

const useBreadcrumbsStyles = () => styles;
export default useBreadcrumbsStyles;
